import { EditModuleDto, ModuleDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { ModuleSettingsForm } from './form';

export class ModuleSettingsFormOutput {
  name?: string;
  status?: string;
  position?: { x?: number; y?: number; a?: number };
  dimensions?: { widthCm?: number; heightCm?: number; depthCm?: number };

  constructor(form: ModuleSettingsForm) {
    if (form.name !== undefined) this.name = form.name;
    if (form.status !== undefined) this.status = form.status;
    if (form.position !== undefined) this.position = form.position;
    if (form.dimensions !== undefined) this.dimensions = form.dimensions;
  }

  static FromModuleDto(module: ModuleDto): ModuleSettingsForm {
    return {
      name: module.name,
      status: module.status,
      position: {
        x: module.bottomLeftPosition?.x,
        y: module.bottomLeftPosition?.y,
        a: module.bottomLeftPosition?.a
      },
      dimensions: {
        widthCm: module.dimensions?.widthCm,
        heightCm: module.dimensions?.heightCm,
        depthCm: module.dimensions?.depthCm
      }
    };
  }

  static ToEditModuleDto(output: ModuleSettingsFormOutput): EditModuleDto {
    return {
      name: output.name,
      ...(output.position && {
        bottomLeftPosition: {
          x: output.position.x!,
          y: output.position.y!,
          a: output.position.a!
        }
      })
    };
  }
}
